// src/utils/dateUtils.js

/**
 * Formata um objeto de Data para a string 'YYYY-MM-DD', ignorando o fuso horário.
 * Esta é a função principal para garantir que a data selecionada seja a data usada.
 * @param {Date} date O objeto de data.
 * @returns {string} A data formatada como "YYYY-MM-DD".
 */
export const formatDateToYYYYMMDD = (date) => {
  if (!(date instanceof Date) || isNaN(date)) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
